import { createAsyncThunk } from '@reduxjs/toolkit';

import { partnerAPI } from '@/modules/partner/api';
import { IPartner } from '@/modules/partner/model';
import { namespace } from '@/modules/partner/namespace';
import { getPartner } from '@/modules/partner/store/selectors';
import { getUserData } from '@/modules/user/store/selectors';
import type { RootState } from '@/root-store';

import { setPartner } from '../actions';

const reloadPartner = createAsyncThunk(
  `${namespace}/reload-partner`,
  async (_, { dispatch, getState }): Promise<IPartner> => {
    const me = getUserData(getState() as RootState);

    if (me.roles.includes('partner')) {
      const updated = await partnerAPI.readPartner(me);

      dispatch(setPartner(updated));

      return updated;
    }

    return getPartner(getState() as RootState);
  },
);

export { reloadPartner };
